import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './guards/auth.guard';
import { NotfoundComponent } from './layout/notfound/notfound.component';
import { RoleGuard } from './guards/role.guard';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              loadChildren: () =>
                import('./layout/dashboard/dashboard.module').then(
                  (m) => m.DashboardModule
                ),
            },
            {
              path: 'tms',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_TMS'] },
              loadChildren: () =>
                import('./layout/tms/tms-routing.module').then(
                  (m) => m.TmsRoutingModule
                ),
            },
            {
              path: 'idp',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_IDP', 'ROLE_TMS'] },
              loadChildren: () =>
                import('./layout/idp/idp-routing.module').then(
                  (m) => m.IdpRoutingModule
                ),
            },
            {
              path: 'customer-services',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_CUSTOMER_SERVICES'] },
              loadChildren: () =>
                import('./layout/customer-services/customer-services-routing.module').then(
                  (m) => m.CustomerServicesRoutingModule
                ),
            },
            {
              path: 'warehouse',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_WAREHOUSE'] },
              loadChildren: () =>
                import('./layout/warehouse/warehouse-routing.module').then(
                  (m) => m.WarehouseRoutingModule
                ),
            },
            {
              path: 'custom-services',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_CUSTOM_SERVICE'] },
              loadChildren: () =>
                import('./layout/custom-services/custom-services-routing.module').then(
                  (m) => m.CustomServicesRoutingModule
                ),
            },
            {
              path: 'external-data',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_EXTERNAL_DATA'] },
              loadChildren: () =>
                import('./layout/external-data/external-data.module').then(
                  (m) => m.ExternalData
                ),
            },
            {
              path: 'inventory',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_INVENTORY'] },
              loadChildren: () =>
                import('./layout/inventory/inventory-routing.module').then(
                  (m) => m.InventoryRoutingModule
                ),
            },
            {
              // Sin rol de módulo: basta con estar autenticado (AuthGuard del padre); la API decide por proyecto.
              path: 'test-tracking',
              loadChildren: () =>
                import('./layout/test-tracking/test-tracking-routing.module').then(
                  (m) => m.TestTrackingRoutingModule
                ),
            },
            {
              path: 'expenses',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_EXPENSES', 'ROLE_EX_ADMIN'] },
              loadChildren: () =>
                import('./layout/expenses/expenses-routing.module').then(
                  (m) => m.ExpensesRoutingModule
                ),
            },
            {
              path: 'planification',
              title: 'Conva Tools / Planification',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_PLANIFICATION'] },
              loadComponent: () =>
                import('./layout/planification/planification.component').then(
                  (m) => m.PlanificationComponent
                ),
            },
            {
              path: 'administration',
              canActivate: [RoleGuard],
              data: { roles: ['ROLE_ADMINISTRATION'] },
              loadChildren: () =>
                import('./layout/administration/administration-routing.module').then(
                  (m) => m.AdministrationRoutingModule
                ),
            },
            {
              path: 'authorization-requests',
              canActivate: [RoleGuard],
              data: {
                roles: ['ROLE_AUTHORIZATION_REQUESTS', 'ROLE_ADMIN', 'ROLE_AR_AUTHORIZER', 'ROLE_AR_ADMIN']
              },
              loadChildren: () =>
                import('./layout/authorization-requests/authorization-requests-routing.module').then(
                  (m) => m.AuthorizationRequestsRoutingModule
                ),
            },
          ],
        },
        {
          path: 'auth',
          loadChildren: () =>
            import('./auth/auth.module').then((m) => m.AuthModule),
        },
        // { path: 'notfound', component: NotfoundComponent },
        { path: '**', component: NotfoundComponent },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
